import { FC } from 'react';

import { Head, Link } from '@inertiajs/react';

import logoLight from '/assets/logo-light-theme.svg';
import logoDark from '/assets/logo-dark-theme.svg';
import { useResolvedTheme } from '../../hooks/useResolvedTheme';

const About: FC = () => {
    const resolvedTheme = useResolvedTheme();
    const logo = resolvedTheme === 'dark' ? logoDark : logoLight;

    return (
        <>
            <Head title="Про нас | CartOn" />
            <div className="container mx-auto max-w-4xl py-10">
                <div className="mb-10 flex flex-col items-center gap-8 md:flex-row">
                    <div className="flex-1">
                        <h1 className="mb-4 text-3xl font-bold">Про CartOn</h1>
                        <p className="text-lg text-muted-foreground">
                            Перший український маркетплейс для колекційних
                            карткових ігор. Ми об&#39;єднуємо фанатів та
                            колекціонерів, створюючи безпечний простір для
                            купівлі та продажу.
                        </p>
                    </div>
                    <div className="flex w-48 flex-shrink-0 justify-center md:w-64">
                        <img
                            src={logo}
                            alt="CartOn Logo"
                            className="h-auto w-full"
                        />
                    </div>
                </div>

                <div className="mb-12 grid gap-8 md:grid-cols-2">
                    <div className="rounded-lg border bg-card p-6 shadow-sm">
                        <h2 className="mb-3 text-xl font-semibold">
                            Наша місія
                        </h2>
                        <p className="text-sm text-muted-foreground">
                            Ми прагнемо розвивати культуру TCG (Trading Card
                            Games) в Україні, роблячи процес обміну та торгівлі
                            картами зручним, прозорим та доступним для кожного.
                            Ми віримо, що кожна карта має знайти свого власника.
                        </p>
                    </div>
                    <div className="rounded-lg border bg-card p-6 shadow-sm">
                        <h2 className="mb-3 text-xl font-semibold">
                            Що ми пропонуємо
                        </h2>
                        <p className="text-sm text-muted-foreground">
                            Зручний пошук карток, безпечні угоди, систему
                            рейтингів для продавців та покупців, а також базу
                            даних карток для найпопулярніших ігор: One Piece,
                            Pok&#233;mon, Magic: The Gathering, Yu-Gi-Oh! та
                            інших.
                        </p>
                    </div>
                </div>

                <div className="space-y-6">
                    <h2 className="text-2xl font-bold">Чому обирають нас?</h2>
                    <div className="grid gap-6 sm:grid-cols-3">
                        <div>
                            <h3 className="mb-2 font-semibold">
                                Локальна спільнота
                            </h3>
                            <p className="text-sm text-muted-foreground">
                                Купуйте у продавців з України, заощаджуйте на
                                доставці та спілкуйтеся з однодумцями.
                            </p>
                        </div>
                        <div>
                            <h3 className="mb-2 font-semibold">
                                Актуальні ціни
                            </h3>
                            <p className="text-sm text-muted-foreground">
                                Слідкуйте за ринковими тенденціями та купуйте
                                картки за чесними цінами.
                            </p>
                        </div>
                        <div>
                            <h3 className="mb-2 font-semibold">Зручність</h3>
                            <p className="text-sm text-muted-foreground">
                                Простий інтерфейс, швидке створення оголошень та
                                зручні інструменти управління колекцією.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-12 text-center">
                    <h2 className="mb-4 text-2xl font-bold">
                        Приєднуйтесь до нас!
                    </h2>
                    <p className="mb-6 text-muted-foreground">
                        Почніть свою колекцію або знайдіть нових власників для
                        своїх карток вже сьогодні.
                    </p>
                    <Link
                        href="/sign_up"
                        className="inline-flex h-11 items-center justify-center rounded-xl bg-primary px-8 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
                    >
                        Створити акаунт
                    </Link>
                </div>
            </div>
        </>
    );
};

export default About;
